import type { StringGUID } from "@pdfking/tfunc"
import type { VirtualFile } from "../types/files/VirtualFile"
import { FullMethodDispatcher } from "@pdfking/tfunc"
import { VirtualFileType } from "../types/files/VirtualFileType"

const get_guid = (file: { guid: StringGUID }) => file.guid
const get_content_guid = (file: { content: { guid: StringGUID } }) =>
  file.content.guid

export const FileContentGUID = FullMethodDispatcher<[VirtualFile], StringGUID>({
  [VirtualFileType.GENERATED_FILE]: get_guid,
  [VirtualFileType.MULTI_PAGE_PDF]: get_content_guid,
  [VirtualFileType.REMOTE_FILE]: get_guid,
  [VirtualFileType.REMOTE_FILE_CHUNK]: get_content_guid,
  [VirtualFileType.SINGLE_PAGE_IMAGE]: get_content_guid,
  [VirtualFileType.SINGLE_PAGE_PDF]: get_content_guid,
  [VirtualFileType.ZIP_FILE]: get_content_guid,
})
